import { UnitConversions } from '../common/constants'
import { UnitCategoryId } from './enums'

export const UNIT_CONVERSIONS: UnitConversions = {
  [UnitCategoryId.Volume]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Volume,
      baseUnitId: 65,
      shortName: 'Vol',
      longName: 'Volume',
      shortUnits: 'm3',
      longUnits: 'cubic meters',
    },
    available: {
      '1': 'cubic feet',
      '2': 'US gallons',
      '3': 'acre foot',
      '65': 'cubic meters',
      '66': 'litres',
    },
    abbreviations: {
      '1': 'ft3',
      '2': 'gal',
      '3': 'acre-ft',
      '65': 'm3',
      '66': 'L',
    },
    formulas: {
      '1': '@[35.31466657222261]*',
      '2': '@[264.17205124155845]*',
      '3': '@[1233.48185532]/',
      '65': '@',
      '66': '@[1000]*',
    },
  },
  [UnitCategoryId.VolumeRate]: {
    metadata: {
      unitCategoryId: UnitCategoryId.VolumeRate,
      baseUnitId: 65,
      shortName: 'VRate',
      longName: 'Volume Rate',
      shortUnits: 'm3/sec',
      longUnits: 'cubic meters / second',
    },
    available: {
      '1': 'cubic feet / second',
      '2': 'cubic feet / minute',
      '3': 'cubic feet / hour',
      '4': 'cubic feet / day',
      '5': 'US gallons / second',
      '6': 'US gallons / minute',
      '7': 'US gallons / hour',
      '8': 'US gallons / day',
      '65': 'cubic meters / second',
      '66': 'cubic meters / minute',
      '67': 'cubic meters / hour',
      '68': 'cubic meters / day',
      '69': 'litres / second',
      '70': 'litres / minute',
      '71': 'litres / hour',
      '72': 'litres / day',
    },
    abbreviations: {
      '1': 'ft3/sec',
      '2': 'ft3/min',
      '3': 'ft3/hr',
      '4': 'ft3/day',
      '5': 'gal/sec',
      '6': 'gal/min',
      '7': 'gal/hr',
      '8': 'gal/day',
      '65': 'm3/sec',
      '66': 'm3/min',
      '67': 'm3/hr',
      '68': 'm3/day',
      '69': 'L/sec',
      '70': 'L/min',
      '71': 'L/hr',
      '72': 'L/day',
    },
    formulas: {
      '1': '@[35.31466657222261]*',
      '2': '@[2118.8799727596793]*',
      '3': '@[127132.79836558129]*',
      '4': '@[3051187.1607739585]*',
      '5': '@[264.17205124155845]*',
      '6': '@[15850.323074493424]*',
      '7': '@[951019.3844695903]*',
      '8': '@[22824465.22727069]*',
      '65': '@',
      '66': '@[60]*',
      '67': '@[3600]*',
      '68': '@[86400]*',
      '69': '@[1000]*',
      '70': '@[60000]*',
      '71': '@[3600000]*',
      '72': '@[86400000]*',
    },
  },
  [UnitCategoryId.Temperature]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Temperature,
      baseUnitId: 65,
      shortName: 'Temp',
      longName: 'Temperature',
      shortUnits: 'C',
      longUnits: 'Celsius',
    },
    available: {
      '1': 'Fahrenheit',
      '65': 'Celsius',
    },
    abbreviations: {
      '1': 'F',
      '65': 'C',
    },
    formulas: {
      '1': '@[1.8]*[32]+',
      '65': '@',
    },
  },
  [UnitCategoryId.VolumetricWaterContent]: {
    metadata: {
      unitCategoryId: UnitCategoryId.VolumetricWaterContent,
      baseUnitId: 1,
      shortName: 'VWC',
      longName: 'Volumetric Water Content',
      shortUnits: '%',
      longUnits: 'percent',
    },
    available: {
      '1': 'percent',
    },
    abbreviations: {
      '1': '%',
    },
    formulas: {
      '1': '@',
    },
  },
  [UnitCategoryId.VolumePulse]: {
    metadata: {
      unitCategoryId: UnitCategoryId.VolumePulse,
      baseUnitId: 65,
      shortName: 'VPulse',
      longName: 'Volume / Pulse',
      shortUnits: 'm3',
      longUnits: 'cubic meters',
    },
    available: {
      '1': 'cubic feet',
      '2': 'US gallons',
      '3': 'acre foot',
      '65': 'cubic meters',
      '66': 'litres',
    },
    abbreviations: {
      '1': 'ft3',
      '2': 'gal',
      '3': 'acre-ft',
      '65': 'm3',
      '66': 'L',
    },
    formulas: {
      '1': '@[35.31466657222261]*',
      '2': '@[264.17205124155845]*',
      '3': '@[1233.48185532]/',
      '65': '@',
      '66': '@[1000]*',
    },
  },
  [UnitCategoryId.DepthHeightDistance]: {
    metadata: {
      unitCategoryId: UnitCategoryId.DepthHeightDistance,
      baseUnitId: 65,
      shortName: 'Depth',
      longName: 'Depth, Height, Distance',
      shortUnits: 'm',
      longUnits: 'meters',
    },
    available: {
      '1': 'inches',
      '2': 'feet',
      '3': 'yards',
      '4': 'miles',
      '65': 'meters',
      '66': 'millimeters',
      '67': 'centimeters',
      '68': 'kilometers',
    },
    abbreviations: {
      '1': 'in',
      '2': 'ft',
      '3': 'yd',
      '4': 'mi',
      '65': 'm',
      '66': 'mm',
      '67': 'cm',
      '68': 'km',
    },
    formulas: {
      '1': '@[0.0254]/',
      '2': '@[0.3048]/',
      '3': '@[0.9144]/',
      '4': '@[1609.344]/',
      '65': '@',
      '66': '@[1000]*',
      '67': '@[100]*',
      '68': '@[1000]/',
    },
  },
  [UnitCategoryId.Pressure]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Pressure,
      baseUnitId: 65,
      shortName: 'Pres',
      longName: 'Pressure',
      shortUnits: 'Pa',
      longUnits: 'pascals',
    },
    available: {
      '1': 'pounds / square inch',
      '2': 'atmospheres',
      '3': 'inches of water',
      '4': 'inches of mercury',
      '65': 'pascals',
      '66': 'kilopascals',
      '67': 'bars',
      '68': 'millimeters of mercury',
    },
    abbreviations: {
      '1': 'psi',
      '2': 'atm',
      '3': 'inH2O',
      '4': 'inHg',
      '65': 'Pa',
      '66': 'kPa',
      '67': 'bar',
      '68': 'mmHg',
    },
    formulas: {
      '1': '@[6894.75728]/',
      '2': '@[101325.01]/',
      '3': '@[249.08890833333]/',
      '4': '@[3386.3886666667]/',
      '65': '@',
      '66': '@[1000]/',
      '67': '@[100000]/',
      '68': '@[133.32239]/',
    },
  },
  [UnitCategoryId.ElectricPotentialDifference]: {
    metadata: {
      unitCategoryId: UnitCategoryId.ElectricPotentialDifference,
      baseUnitId: 1,
      shortName: 'EPD',
      longName: 'Electric Potential Difference',
      shortUnits: 'V',
      longUnits: 'volts',
    },
    available: {
      '1': 'volts',
      '2': 'millivolts',
    },
    abbreviations: {
      '1': 'V',
      '2': 'mV',
    },
    formulas: {
      '1': '@',
      '2': '@[1000]*',
    },
  },
  [UnitCategoryId.SwitchContact]: {
    metadata: {
      unitCategoryId: UnitCategoryId.SwitchContact,
      baseUnitId: 1,
      shortName: 'Switch',
      longName: 'Switch Contact',
      shortUnits: '%',
      longUnits: 'percent',
    },
    available: {
      '1': 'percent',
    },
    abbreviations: {
      '1': '%',
    },
    formulas: {
      '1': '@',
    },
  },
  [UnitCategoryId.TotalVolume]: {
    metadata: {
      unitCategoryId: UnitCategoryId.TotalVolume,
      baseUnitId: 65,
      shortName: 'TVol',
      longName: 'Total Volume',
      shortUnits: 'm3',
      longUnits: 'cubic meters',
    },
    available: {
      '1': 'cubic feet',
      '2': 'US gallons',
      '3': 'acre foot',
      '65': 'cubic meters',
      '66': 'litres',
    },
    abbreviations: {
      '1': 'ft3',
      '2': 'gal',
      '3': 'acre-ft',
      '65': 'm3',
      '66': 'L',
    },
    formulas: {
      '1': '@[35.31466657222261]*',
      '2': '@[264.17205124155845]*',
      '3': '@[1233.48185532]/',
      '65': '@',
      '66': '@[1000]*',
    },
  },
  [UnitCategoryId.PressureGauge]: {
    metadata: {
      unitCategoryId: UnitCategoryId.PressureGauge,
      baseUnitId: 65,
      shortName: 'PresG',
      longName: 'Pressure Gauge',
      shortUnits: 'Pag',
      longUnits: 'pascals',
    },
    available: {
      '1': 'pounds / square inch',
      '2': 'atmospheres',
      '3': 'inches of water',
      '4': 'inches of mercury',
      '65': 'pascals',
      '66': 'kilopascals',
      '67': 'bars',
      '68': 'millimeters of mercury',
    },
    abbreviations: {
      '1': 'psig',
      '2': 'atmg',
      '3': 'inH2Og',
      '4': 'inHgg',
      '65': 'Pag',
      '66': 'kPag',
      '67': 'barg',
      '68': 'mmHgg',
    },
    formulas: {
      '1': '@[6894.75728]/',
      '2': '@[101325.01]/',
      '3': '@[249.08890833333]/',
      '4': '@[3386.3886666667]/',
      '65': '@',
      '66': '@[1000]/',
      '67': '@[100000]/',
      '68': '@[133.32239]/',
    },
  },
  [UnitCategoryId.WindDirection]: {
    metadata: {
      unitCategoryId: UnitCategoryId.WindDirection,
      baseUnitId: 1,
      shortName: 'WDir',
      longName: 'Wind Direction',
      shortUnits: 'deg',
      longUnits: 'degrees',
    },
    available: {
      '1': 'degrees',
    },
    abbreviations: {
      '1': 'deg',
    },
    formulas: {
      '1': '@',
    },
  },
  [UnitCategoryId.WindSpeed]: {
    metadata: {
      unitCategoryId: UnitCategoryId.WindSpeed,
      baseUnitId: 65,
      shortName: 'WSpd',
      longName: 'Wind Speed',
      shortUnits: 'm/s',
      longUnits: 'meters / second',
    },
    available: {
      '1': 'feet / second',
      '2': 'miles / hour',
      '65': 'meters / second',
      '66': 'kilometers / hour',
    },
    abbreviations: {
      '1': 'f/s',
      '2': 'mph',
      '65': 'm/s',
      '66': 'kph',
    },
    formulas: {
      '1': '@[3.280839895013123]*',
      '2': '@[2.2369362920544025]*',
      '65': '@',
      '66': '@[3.6]*',
    },
  },
  [UnitCategoryId.Rainfall]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Rainfall,
      baseUnitId: 65,
      shortName: 'Rain',
      longName: 'Rainfall',
      shortUnits: 'm',
      longUnits: 'meters',
    },
    available: {
      '1': 'inches',
      '2': 'feet',
      '3': 'yards',
      '65': 'meters',
      '66': 'millimeters',
      '67': 'centimeters',
    },
    abbreviations: {
      '1': 'in',
      '2': 'ft',
      '3': 'yd',
      '65': 'm',
      '66': 'mm',
      '67': 'cm',
    },
    formulas: {
      '1': '@[0.0254]/',
      '2': '@[0.3048]/',
      '3': '@[0.9144]/',
      '65': '@',
      '66': '@[1000]*',
      '67': '@[100]*',
    },
  },
  [UnitCategoryId.SolarRadiation]: {
    metadata: {
      unitCategoryId: UnitCategoryId.SolarRadiation,
      baseUnitId: 65,
      shortName: 'SolRad',
      longName: 'Solar Radiation',
      shortUnits: 'W/m2',
      longUnits: 'watts / square meter',
    },
    available: {
      '65': 'watts / square meter',
    },
    abbreviations: {
      '65': 'W/m2',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.Humidity]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Humidity,
      baseUnitId: 1,
      shortName: 'HMD',
      longName: 'Humidity',
      shortUnits: '%',
      longUnits: 'percent',
    },
    available: {
      '1': 'percent',
    },
    abbreviations: {
      '1': '%',
    },
    formulas: {
      '1': '@',
    },
  },
  [UnitCategoryId.WindDistribution]: {
    metadata: {
      unitCategoryId: UnitCategoryId.WindDistribution,
      baseUnitId: 1,
      shortName: 'WDst',
      longName: 'Wind Distribution',
      shortUnits: '%',
      longUnits: 'percent',
    },
    available: {
      '1': 'percent',
    },
    abbreviations: {
      '1': '%',
    },
    formulas: {
      '1': '@',
    },
  },
  [UnitCategoryId.RainfallRate]: {
    metadata: {
      unitCategoryId: UnitCategoryId.RainfallRate,
      baseUnitId: 65,
      shortName: 'RRate',
      longName: 'Rainfall Rate',
      shortUnits: 'mm/min',
      longUnits: 'millimeters / minute',
    },
    available: {
      '1': 'inches / minute',
      '2': 'inches / hour',
      '65': 'millimeters / minute',
      '66': 'millimeters / hour',
    },
    abbreviations: {
      '1': 'in/min',
      '2': 'in/hr',
      '65': 'mm/min',
      '66': 'mm/hr',
    },
    formulas: {
      '1': '@[25.4]/',
      '2': '@[2.3622047244094]*',
      '65': '@',
      '66': '@[60]*',
    },
  },
  [UnitCategoryId.DissolvedOxygen]: {
    metadata: {
      unitCategoryId: UnitCategoryId.DissolvedOxygen,
      baseUnitId: 65,
      shortName: 'DissO2',
      longName: 'Dissolved Oxygen',
      shortUnits: 'mg/L',
      longUnits: 'milligrams per liter',
    },
    available: {
      '65': 'milligrams per liter',
    },
    abbreviations: {
      '65': 'mg/L',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.Turbidity]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Turbidity,
      baseUnitId: 65,
      shortName: 'Turbidity',
      longName: 'Turbidity',
      shortUnits: 'NTU',
      longUnits: 'nephelometric turb. unit',
    },
    available: {
      '65': 'nephelometric turb. unit',
    },
    abbreviations: {
      '65': 'NTU',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.DissolvedSolids]: {
    metadata: {
      unitCategoryId: UnitCategoryId.DissolvedSolids,
      baseUnitId: 65,
      shortName: 'DissSolids',
      longName: 'Dissolved Solids',
      shortUnits: 'ppt',
      longUnits: 'parts per trillion',
    },
    available: {
      '65': 'parts per trillion',
    },
    abbreviations: {
      '65': 'ppt',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.Nitrates]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Nitrates,
      baseUnitId: 65,
      shortName: 'Nitrates',
      longName: 'Nitrates',
      shortUnits: 'mg/L',
      longUnits: 'milligrams per liter',
    },
    available: {
      '65': 'milligrams per liter',
    },
    abbreviations: {
      '65': 'mg/L',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.SpecificConductivity]: {
    metadata: {
      unitCategoryId: UnitCategoryId.SpecificConductivity,
      baseUnitId: 65,
      shortName: 'SpecCond',
      longName: 'Specific Conductivity',
      shortUnits: 'uS/cm',
      longUnits: 'microsiemens / cm ',
    },
    available: {
      '65': 'microsiemens / cm ',
    },
    abbreviations: {
      '65': 'uS/cm',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.Salinity]: {
    metadata: {
      unitCategoryId: UnitCategoryId.Salinity,
      baseUnitId: 65,
      shortName: 'Salinity',
      longName: 'Salinity',
      shortUnits: 'PSU',
      longUnits: 'practical salinity units',
    },
    available: {
      '65': 'practical salinity units',
    },
    abbreviations: {
      '65': 'PSU',
    },
    formulas: {
      '65': '@',
    },
  },
  [UnitCategoryId.WaterTemperature]: {
    metadata: {
      unitCategoryId: UnitCategoryId.WaterTemperature,
      baseUnitId: 65,
      shortName: 'H2OTemp',
      longName: 'Water Temperature',
      shortUnits: 'C',
      longUnits: 'Celsius',
    },
    available: {
      '1': 'Fahrenheit',
      '65': 'Celsius',
    },
    abbreviations: {
      '1': 'F',
      '65': 'C',
    },
    formulas: {
      '1': '@[1.8]*[32]+',
      '65': '@',
    },
  },
  [UnitCategoryId.SoilTemperature]: {
    metadata: {
      unitCategoryId: UnitCategoryId.SoilTemperature,
      baseUnitId: 65,
      shortName: 'SoilTemp',
      longName: 'Soil Temperature',
      shortUnits: 'C',
      longUnits: 'Celsius',
    },
    available: {
      '1': 'Fahrenheit',
      '65': 'Celsius',
    },
    abbreviations: {
      '1': 'F',
      '65': 'C',
    },
    formulas: {
      '1': '@[1.8]*[32]+',
      '65': '@',
    },
  },
}
